import { FilterOperator } from '../model';

/**
 * Default operators for string/text data extension fields
 */
export const STRING_OPERATORS: FilterOperator[] = [
  FilterOperator.STARTS_WITH,
  FilterOperator.EQUALS,
  FilterOperator.NOT_EQUALS,
  FilterOperator.IS_EMPTY,
  FilterOperator.EXISTS,
];
